import { UpdateResolver } from "@urql/exchange-graphcache";
import { GetAppsForOrgDocument, GetOrgDocument, Organization, UpdateOrganizationMutationVariables } from "generated/graphql";

function updateOrganization(cached: Organization, vars: UpdateOrganizationMutationVariables) {
    Object.assign(cached, vars.org);
}

export const orgUpdates: {
    [fieldName: string]: UpdateResolver;
} = {
    updateOrg: (result: any, args, cache, info) => {
        if (result.updateOrg) {
            const vars = info.variables as UpdateOrganizationMutationVariables;
            const orgId = vars.orgId;
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetOrgDocument,
                variables: { orgId }
            }, data => {
                if (typeof data?.org === "object") {
                    updateOrganization(data.org as Organization, vars);
                }

                return data;
            });

            // Note: Is this the cause of some issues for us?
            cache.updateQuery({
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetAppsForOrgDocument,
                variables: { orgId }
            }, data => {
                if (typeof data?.org === "object") {
                    updateOrganization(data.org as Organization, vars);
                }

                return data;
            });
        }
    }

};